import { motion } from "framer-motion";
import { Ghost, Cat } from "lucide-react";
import { Cobweb } from "./Cobweb";

export const FinalCta = ({ event }) => {
  return (
    <section className="relative bg-black py-28 sm:py-40 px-4 sm:px-6 overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 tile-grid opacity-50" />
      <div className="absolute inset-0 radial-fade-acid" />
      <Cobweb className="absolute top-0 right-0 w-24 h-24 sm:w-36 sm:h-36 text-white/30 rotate-90" />
      <motion.div
        initial={{ opacity: 0, scale: 0.9, rotate: -6 }}
        whileInView={{ opacity: 0.5, scale: 1, rotate: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="absolute bottom-10 left-6 sm:left-16 text-blood/60"
      >
        <Ghost size={48} strokeWidth={1} />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 0.5, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.15 }}
        className="absolute bottom-14 right-10 sm:right-24 text-acid/50"
      >
        <Cat size={34} strokeWidth={1} />
      </motion.div>

      <div className="relative max-w-3xl mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-extrabold uppercase text-4xl sm:text-6xl tracking-tighter leading-[0.95]"
        >
          One Night.
          <br />
          <span className="text-acid">One Movement.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-6 text-zinc-400 text-base sm:text-lg font-body"
        >
          Berlin meets {event.city}. {event.priceLabel}. Limited tickets.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-10"
        >
          <a
            href={event.ticketUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-get-tickets-btn"
            className="inline-flex items-center gap-3 bg-acid text-black font-display font-extrabold uppercase tracking-wide text-base sm:text-lg px-10 py-5 hover:bg-white transition-colors duration-300 animate-pulse-glow"
          >
            Get Tickets
          </a>
        </motion.div>
      </div>
    </section>
  );
};
